import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeUserAttribute } from "../../actions/auth";
import _ from 'lodash';
import OnboardCarousel from "../../components/onboard/Carousel";
import "./Onboard.scss";

class Onboard extends Component {
  componentDidMount() {
    // From willMount
    const customState = _.get(this.props, "cognitoUser.attributes['custom:state']", null);
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']", '') === 'admin';
    // Onboarding v2 for admins
    if (isAdmin) {
      if (customState === 'onboarding-01' || customState === 'onboarding') {
        this.props.history.push('/onboarding/survey');
      } else if (customState === 'onboarding-02' || customState === 'invited') {
        this.props.history.push('/onboarding/infographics');
      } else if (customState === 'onboarding-03') {
        this.props.history.push('/onboarding/checklist');
      } 
    } else {
      // Onboarding v2 for regular users
      if (customState === 'onboarding-01' || customState === 'onboarding' || customState === 'invited') {
        this.props.history.push('/onboarding/infographics');
      } else if (customState === 'onboarding-02') {
        this.props.history.push('/onboarding/infographics');
      } else if (customState === 'onboarding-03') {
        this.props.history.push('/onboarding/checklist');
      }
    }

    if (customState && (!customState.includes('onboarding') && customState !== 'invited')) {
      this.props.history.push('/dashboard')
    }
    //////
  }

  render() {
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']", '') === 'admin';

    return (
      <div className="onboard-container">
        <OnboardCarousel history={this.props.history} isAdmin={isAdmin} changeUserAttribute={this.props.changeUserAttribute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.tenant,
  cognitoUser: state.auth.cognitoUser
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    changeUserAttribute
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Onboard);
